/**
 * Defines the functions that Actions implement in the appstore
 */

export var ADMIN_SECTION = /*#__PURE__*/function (ADMIN_SECTION) {
  ADMIN_SECTION["SALES"] = "sales";
  ADMIN_SECTION["OAUTH"] = "oauth";
  ADMIN_SECTION["ORDERS"] = "orders";
  ADMIN_SECTION["PRODUCTS"] = "products";
  ADMIN_SECTION["CUSTOMER"] = "customer";
  ADMIN_SECTION["CATEGORIES"] = "categories";
  ADMIN_SECTION["PACKAGEPURCHASE"] = "packagepurchase";
  return ADMIN_SECTION;
}({});